import { isWebAlert } from '@m2h/common/constants';
import Mach from '@m2h/common/Mach';
import {
  getLocalSchemeData, replaceMachSchemeData2Window,
} from '@m2h/common/utils/machUtils';
import {
  _cleanupInvalidHandlers,
  _cleanupCurrentWindowHandlers,
  initMach,
} from './machproH5Base/base-h5';
import { publishMachPageVisibility } from './pageVisibilityLifecycle';

let clearTimer = 0;

export default function machInit() {
  window.Mach = Mach;
  if (isWebAlert) {
    replaceMachSchemeData2Window(getLocalSchemeData());
  }

  // 页面可见性变化事件
  document.addEventListener('visibilitychange', () => {
    publishMachPageVisibility(Mach, !document.hidden);
  });

  // 页面卸载时清理事件处理器
  window.addEventListener('beforeunload', _cleanupCurrentWindowHandlers);
  window.addEventListener('unload', _cleanupCurrentWindowHandlers);

  if (!clearTimer) {
    // 定期清理失效的事件处理器（每30秒执行一次）
    clearTimer = setInterval(() => {
      _cleanupInvalidHandlers();
    }, 30000);
  }

  initMach()
    .then(() => {
      // @ts-ignore
      if (Mach.env.__ready) {
        // @ts-ignore
        Mach.env.__ready(1);
      }
    })
    .catch((e) => {
      // @ts-ignore
      if (Mach.env.__ready) {
        // @ts-ignore
        Mach.env.__ready(0);
      }
    });
}
